import { createAction, handleActions } from 'redux-actions'

const setData = createAction('SCREENS/TIMESHEET_POSTING/SET_DATA')
const resetData = createAction('SCREENS/TIMESHEET_POSTING/RESET_DATA')

const defaultState = null

const reducer = handleActions(
  {
    [setData]: (state, action) => action.payload,
    [resetData]: () => defaultState,
  },
  defaultState,
)

export { setData, resetData, reducer }
